// extracted by mini-css-extract-plugin
export default {"inner":"SignIn_inner__GoDGg","inner__title":"SignIn_inner__title__dCabt","inner__text":"SignIn_inner__text__B4zbB","signInForm":"SignIn_signInForm__LzugR"};